import React, { useContext, useState } from "react";
import "../../styles/components/ToolBarLeftPanel.scss";
import ModuleCard from "./ModuleCard";
import expandIcon from "../../images/ic_expand_more_24px (1).svg";
import { CircularProgress } from "@mui/material";
import ValueContext from "../../ContextAPi/appContext";
import { getMlrstatusesInModulecards } from "../../services/apis";
const ModuleCardsWindow = ({
  selectedModulecards,
  setSelectedModule,
  selectedModule,
  openModulesModal,
  setOpenModulesScreen,
  setOpenModulesModal,
  openModulesScreen,
  linkedModulesType,
  handleExpandModuleClaims,
  handleGetChildModules,
  sendAtomDetails2Canvas,
  showModulesSection,
  setShowModulesSection,
  associatedCards,
  noBussinessRules,
  setModuleCardsDataLHS,
  moduleCardsDataLHS,
  isLoading,
  moduleSearchExpression,
  setModuleSearchExpression,
  setIsFirstDropped,
  isFirstDropped,
  mlrStatuses,
  setMlrstatuses,
  setEditModuleClicked,
  deleteModulesOnCanvas,
  setUndoVersion,
  undoVersion,
  undoStack,
  redoStack,
  moduleStatuses,
  setModuleStatuses,
  mergedData,
  setBannerValidationCheck,
  allMustUseDataEmpty,

}) => {
  const appData = useContext(ValueContext);
  const handleEditSelection = () => {
    allMustUseDataEmpty.current = true;
    setBannerValidationCheck(false);
    appData.setnewBanner(false);
    setOpenModulesModal(true);
    setOpenModulesScreen(true);
    setUndoVersion(0);
    undoStack.current = [];
    redoStack.current = [];
    //  setEditModuleClicked(false)
    deleteModulesOnCanvas();
  };

  const getMlrStatuses = () => {
    const idsArray = moduleCardsDataLHS?.map((item) => item.moduleId);
    getMlrstatusesInModulecards(idsArray, async (response, err, errorCode) => {
      if (err) {
        console.log(err);
      } else {
        const data = await response.data;
        setMlrstatuses(data);
      }
    });
  };
  // const mergedData = moduleCardsDataLHS.map((card) => {
  //   const mlrItem = moduleStatuses.find(
  //     (item) => item.moduleDamName === card.contentmoduleName
  //   );

  //   return {
  //     ...card,
  //     mlrStatus: mlrItem ? mlrItem.mlrStatus : null,
  //   };
  // });
  return (
    <>
      <div className="selected-module-window custonScrollBar">
        <div>
          <div className="approve-content">{`Approved Content`}</div>
          <div
            className="mb-3"
            style={{
              width: "100%",
              backgroundColor: "#DDDFDD",
              height: "1px",
              marginTop: "-1px",
            }}
          ></div>
        </div>

        <div className="edit-secContainer">
          <div
            className="edit-section mb-3"
            onClick={handleEditSelection}
            style={{ cursor: "pointer" }}
          >
            Edit Selection
            <img src={expandIcon} />
          </div>
          {isLoading && (
            <>
              <div className="modal-backdrop fade show"> </div>
              <CircularProgress size="30px" className="customLoader" />{" "}
            </>
          )}
          <div className="cardscroll custonScrollBar">
            {mergedData?.map((moduleIds, index) => {
              return (
                <ModuleCard
                  moduleStatuses={moduleStatuses}
                  setModuleStatuses={setModuleStatuses}
                  getMlrStatuses={getMlrStatuses}
                  mlrStatuses={mlrStatuses}
                  setMlrstatuses={setMlrstatuses}
                  setIsFirstDropped={setIsFirstDropped}
                  isFirstDropped={isFirstDropped}
                  key={moduleIds.id}
                  card={moduleIds}
                  setSelectedModule={setSelectedModule}
                  selectedModule={selectedModule}
                  linkedModulesType={linkedModulesType}
                  handleExpandModuleClaims={handleExpandModuleClaims}
                  sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                  handleGetChildModules={handleGetChildModules}
                  associatedCards={associatedCards}
                  noBussinessRules={noBussinessRules}
                  selectedModulecards={selectedModulecards}
                />
              );
            })}{" "}
          </div>
        </div>
      </div>
    </>
  );
};

export default ModuleCardsWindow;
